import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const BANNER_HEIGHT = 240
const BANNER_GAP = 10

function FloatingBanner ({ banner, top, onClose, onHideForDays }) {
  const closeButtonColor = banner.closeButtonColor || '#000000'
  const hideButtonBgColor = banner.hideButtonBgColor || '#000000'
  const hideButtonTextColor = banner.hideButtonTextColor || '#ffffff'

  return (
    <motion.a
      key={banner.storageKey}
      href={banner.href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ x: -300, opacity: 0, top }}
      animate={{ x: 10, opacity: 1, top }}
      exit={{ x: -300, opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed left-0 bg-white shadow-lg rounded-full w-[160px] h-[240px] z-[10]"
    >
      <img src={banner.image} alt="Banner" className="absolute top-0 left-0 w-[160px] h-[240px]" />
      <div
        className="absolute bottom-0 w-[160px] h-[24px] text-[12px] rounded-b-[14px] flex justify-center items-center cursor-pointer select-none"
        style={{ backgroundColor: hideButtonBgColor, color: hideButtonTextColor }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onHideForDays(banner.storageKey)
        }}
      >
        3일간 보지 않기
      </div>
      <div
        className="absolute top-[6px] right-[6px] cursor-pointer select-none"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onClose(banner.storageKey)
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={4} stroke={closeButtonColor} className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </div>
    </motion.a>
  )
}

export default function FloatingBannerGroup ({ banners }) {
  const [visibleKeys, setVisibleKeys] = useState([])

  useEffect(() => {
    const initialVisible = banners.filter((banner) => {
      const hideUntil = localStorage.getItem(banner.storageKey)
      return !hideUntil || new Date() > new Date(hideUntil)
    }).map((banner) => banner.storageKey)
    setVisibleKeys(initialVisible)
  }, [banners])

  const handleClose = (storageKey) => {
    setVisibleKeys((prev) => prev.filter((key) => key !== storageKey))
  }

  const handleHideForDays = (storageKey) => {
    const hideUntil = new Date()
    hideUntil.setDate(hideUntil.getDate() + 3)
    localStorage.setItem(storageKey, hideUntil.toISOString())
    setVisibleKeys((prev) => prev.filter((key) => key !== storageKey))
  }

  const visibleBanners = banners.filter((banner) => visibleKeys.includes(banner.storageKey))
  const totalHeight = visibleBanners.length * BANNER_HEIGHT + (visibleBanners.length - 1) * BANNER_GAP
  const startTop = `calc(50vh - ${totalHeight / 2}px)`

  return (
    <AnimatePresence>
      {visibleBanners.map((banner, index) => {
        const top = `calc(${startTop} + ${index * (BANNER_HEIGHT + BANNER_GAP)}px)`
        return (
          <FloatingBanner
            key={banner.storageKey}
            banner={banner}
            top={top}
            onClose={handleClose}
            onHideForDays={handleHideForDays}
          />
        )
      })}
    </AnimatePresence>
  )
}
